<template>
  <div class="about-page">
    <div class="header">
      <h1 class="page-title">建设项目环境影响评价审批决定公告</h1>
    </div>

    <div class="table-container">
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        style="width: 100%; height: 90%"
        :header-cell-style="{
          backgroundColor: '#f5f7fa',
          color: '#606266',
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: '14px',
        }"
        :cell-style="{ textAlign: 'center', fontSize: '14px' }"
        empty-text="暂无数据"
      >
        <el-table-column
          prop="SUBJECT"
          label="项目名称"
          min-width="300"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="text-ellipsis">
              <el-button type="text" @click="downloadDz(scope.row)">{{
                scope.row.SUBJECT
              }}</el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="PIWENNAME"
          label="批文名称"
          min-width="300"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="text-ellipsis">{{ scope.row.PIWENNAME }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="PIWNENO" label="批文号码" min-width="300">
          <template slot-scope="scope">
            <div class="text-ellipsis">{{ scope.row.PIWNENO }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="PIWENDATE" label="批文时间" min-width="300">
          <template slot-scope="scope">
            <div class="text-ellipsis">
              {{ formatDate(scope.row.PIWENDATE) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="approvalLocation"
          label="批文内容"
          min-width="300"
        >
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="download(scope.row)"
              >点击查看</el-button
            > -->
            <el-button type="text" @click="download(scope.row)"
              >点击查看</el-button
            >
            <!-- <div v-if="scope.row.ATTACH_4 == null">暂无附件</div> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  login,
  AuditDecision,
  FileListDownLoadWithName,
  FileListDownLoadTypeAndID,
} from "@/api/user";
// import { post } from "@/utils/request";

export default {
  name: "AboutPage",
  data() {
    return {
      tableData: [],
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    // this.fetchData();
    this.handleLogin();
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      // 假设日期格式为 "2026-03-27 00:00:00.000"，取空格前部分
      return dateStr.split(" ")[0];
    },
    async handleLogin() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      try {
        const res = await login({ username: "hpuser", password: "5xx$fGc" });
        // this.$message.success("登录成功");
        if (res.data) {
          localStorage.setItem("token", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);

          this.AuditDecision();
        }
        if (res.httpStatusCode == 20001 || res.httpStatusCode == 20002) {
          this.postRefresh();
        }
        console.log(res);
        // 处理 token 等
      } catch (error) {
        // 错误已在拦截器中处理，这里可忽略或补充逻辑
      }
    },
    /**
     * 获取审核决策列表数据
     *
     * @async
     * @returns {Promise<void>} 无返回值，将数据存储到组件的 tableData 和 pagination 中
     */
    async AuditDecision() {
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        };
        const res = await AuditDecision(params);
        console.log(res);
        this.tableData = res.data.records;
        this.pagination.total = res.data.total;
        // 处理 token 等
      } catch (error) {
        // 错误已在拦截器中处理，这里可忽略或补充逻辑
      }
    },

    async postRefresh() {
      try {
        const params = {};

        // 创建 axios 实例，设置超时时间和忽略 SSL 证书验证（如果需要）
        const instance = axios.create({
          timeout: 10000,
          // //如果接口有 SSL 证书问题，可以添加以下配置（生产环境不建议）
          // httpsAgent: new (require("https").Agent)({
          //   rejectUnauthorized: false,
          // }),
        });
        const res = await instance.post(
          "http://211.136.184.90:8090/hp/auth/refresh",
          params,
          {
            headers: {
              "refresh-token": localStorage.getItem("refreshToken"),
            },
          },
        );
        if (res.data) {
          localStorage.setItem("token", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          this.AuditDecision();
        }
      } catch (error) {
        console.error("请求失败:", error);
        this.$message.error("暂无数据");
        // 请求失败时使用模拟数据
      } finally {
        this.loading = false;
      }
    },
    /**
     * 获取一行记录中所有非空的附件ID
     * @param {Object} row - 表格行数据
     * @returns {Array} 非空附件ID数组
     */
    getAttachments(row) {
      const ids = [];
      for (let i = 1; i <= 8; i++) {
        const key = `ATTACH_${i}`;
        const value = row[key];
        if (value && value !== null && value !== "") {
          ids.push(value);
        }
      }
      return ids;
    },
    async download(value) {
      console.log(value); // 记录下载参数
      const attachments = this.getAttachments(value);
      console.log(attachments); // 记录附件ID数组

      const params = { WF_CASEID: attachments, WF_TYPE: "正文" }; // 构建下载请求参数
      const res = await FileListDownLoadTypeAndID(params); // 调用文件下载接口
      window.open(res.data[0].FILEPATH); // 打开下载链接

      // console.log(res); // 记录下载结果
    },
    async downloadDz(value) {
      console.log(value); // 记录下载参数
      const params = { WF_CASEID: value.ATTACH_8 }; // 构建下载请求参数
      const res = await FileListDownLoadWithName(params); // 调用文件下载接口
      window.open(res.data[0].FILEPATH);
      console.log(res); // 记录下载结果
    },
    // 判断文本是否溢出（简单实现）
    isTextOverflow(text) {
      if (!text) return false;
      // 这里可以根据实际情况调整长度阈值
      return text.length > 20;
    },

    // 获取数据
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          startTime: "",
          endTime: "",
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          type: 1,
        };

        // 创建 axios 实例，设置超时时间和忽略 SSL 证书验证（如果需要）
        const instance = axios.create({
          timeout: 10000,
          // //如果接口有 SSL 证书问题，可以添加以下配置（生产环境不建议）
          // httpsAgent: new (require("https").Agent)({
          //   rejectUnauthorized: false,
          // }),
        });

        const response = await instance.get(
          this.$global.appConfig.apiBaseUrl +
            "/admin-api/huanbao/AuditDecision/List",
          { params },
        );
        console.log(response);
        if (response.data.code == 0) {
          // 根据实际接口返回数据结构调整
          const result = response.data.data;
          this.tableData = result.records || result.list || [];
          this.pagination.total = result.total || 0;
        } else {
          this.$message.error(response.data.message || "获取数据失败");
          // 如果接口失败，使用模拟数据
          // this.useMockData();
        }
      } catch (error) {
        console.error("请求失败:", error);
        this.$message.error("暂无数据");
        // 请求失败时使用模拟数据
        this.useMockData();
      } finally {
        this.loading = false;
      }
    },

    // 使用模拟数据（备用）
    useMockData() {
      this.tableData = [
        {
          projectName: "建华南路（上海）商业改造项目",
          approvalTitle: "关于建华南路（上海）商业改造项目环境影响评价的批复",
          documentNumber: "沪环评〔2023〕001号",
          approvalDate: "2023-03-15",
          approvalLocation: "上海市生态环境局",
        },
        {
          projectName: "上海万国高速公路示范项目",
          approvalTitle: "上海万国高速公路示范项目环境影响报告书审批决定",
          documentNumber: "沪交环〔2023〕005号",
          approvalDate: "2023-02-28",
          approvalLocation: "上海市交通委员会",
        },
        {
          projectName: "粤航江运通道建设用地建设工程",
          approvalTitle: "粤航江运通道建设用地建设工程环评审批公告",
          documentNumber: "粤环审〔2023〕012号",
          approvalDate: "2023-04-10",
          approvalLocation: "广东省生态环境厅",
        },
        {
          projectName: "上海港高速道路工程建设、配套设施项目",
          approvalTitle: "上海港高速道路工程及配套设施项目环评批复",
          documentNumber: "沪港环〔2023〕008号",
          approvalDate: "2023-03-22",
          approvalLocation: "上海市港口管理局",
        },
        {
          projectName: "粤航区电力有限公司建设项目扩产许可证项目",
          approvalTitle: "粤航区电力公司扩建项目环境影响评价审批决定",
          documentNumber: "粤电环〔2023〕015号",
          approvalDate: "2023-05-06",
          approvalLocation: "广东省电力监管局",
        },
        {
          projectName: "珠海港高速（上海）商业改造示范项目",
          approvalTitle: "珠海港高速商业改造示范项目环评审批公示",
          documentNumber: "珠环公〔2023〕003号",
          approvalDate: "2023-01-18",
          approvalLocation: "珠海市生态环境局",
        },
        {
          projectName: "上海地铁产业园建设项目开发项目",
          approvalTitle: "上海地铁产业园开发项目环境影响评价审批公告",
          documentNumber: "沪地铁环〔2023〕007号",
          approvalDate: "2023-04-05",
          approvalLocation: "上海市轨道交通管理局",
        },
        {
          projectName: "芜湖市中铁（上海）商业改造项目及规划项目",
          approvalTitle: "芜湖市中铁商业改造项目环评批复",
          documentNumber: "皖环审〔2023〕009号",
          approvalDate: "2023-03-30",
          approvalLocation: "安徽省生态环境厅",
        },
        {
          projectName: "上海地铁轨道交通建设项目",
          approvalTitle: "上海地铁轨道交通项目环境影响报告书审批决定",
          documentNumber: "沪轨交环〔2023〕004号",
          approvalDate: "2023-02-14",
          approvalLocation: "上海市轨道交通管理局",
        },
        {
          projectName: "长江流域生态环境保护综合治理项目",
          approvalTitle: "长江流域生态保护治理工程环评审批公告",
          documentNumber: "长环审〔2023〕020号",
          approvalDate: "2023-05-20",
          approvalLocation: "长江流域生态环境监督管理局",
        },
        {
          projectName: "粤港澳大湾区交通枢纽建设项目",
          approvalTitle: "粤港澳大湾区交通枢纽环评批复",
          documentNumber: "粤湾环〔2023〕018号",
          approvalDate: "2023-04-25",
          approvalLocation: "广东省发展和改革委员会",
        },
        {
          projectName: "上海市中心城区老旧小区改造项目",
          approvalTitle: "市中心老旧小区改造项目环境影响评价审批",
          documentNumber: "沪住建环〔2023〕011号",
          approvalDate: "2023-03-08",
          approvalLocation: "上海市住房和城乡建设管理委员会",
        },
        {
          projectName: "新能源汽车产业园配套设施项目",
          approvalTitle: "新能源汽车产业园配套项目环评审批决定",
          documentNumber: "沪汽环〔2023〕006号",
          approvalDate: "2023-02-22",
          approvalLocation: "上海市经济和信息化委员会",
        },
        {
          projectName: "长三角生态绿色一体化示范区项目",
          approvalTitle: "长三角生态示范区项目环境影响报告书批复",
          documentNumber: "长三角环〔2023〕002号",
          approvalDate: "2023-01-30",
          approvalLocation: "长三角区域合作办公室",
        },
        {
          projectName: "浦东新区国际机场扩建项目",
          approvalTitle: "浦东国际机场扩建工程环评审批公告",
          documentNumber: "沪机场环〔2023〕014号",
          approvalDate: "2023-05-15",
          approvalLocation: "上海机场集团",
        },
      ];
      this.pagination.total = this.tableData.length;
    },

    // 每页条数改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNo = 1; // 重置到第一页
      // this.fetchData();
      this.AuditDecision();
    },

    // 当前页改变
    handleCurrentChange(pageNo) {
      this.pagination.pageNo = pageNo;
      // this.fetchData();
      this.AuditDecision();
    },
  },
};
</script>

<style scoped>
.about-page {
  height: 97vh;
  display: flex;
  flex-direction: column;
  /* background-color: #f8f9fa; */
  overflow: hidden;
}

.header {
  flex-shrink: 0;
  background: white;
  padding: 20px 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.page-title {
  text-align: center;
  margin: 0;
  color: #303133;
  font-size: 24px;
  font-weight: 600;
}

.table-container {
  flex: 1;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 文本溢出省略号样式 */
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  font-size: 12px;
}

/* 表格样式优化 */
:deep(.el-table) {
  flex: 1;
  font-size: 14px;
  height: 100% !important;
}

:deep(.el-table__body-wrapper) {
  height: calc(100% - 44px) !important;
  overflow: auto;
}

:deep(.el-table th) {
  background-color: #f5f7fa !important;
  padding: 12px 0;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table .cell) {
  padding: 0 12px;
  line-height: 1.4;
  /* 确保单元格内容也应用省略号 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.el-table--border) {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

:deep(.el-table--border th) {
  border-right: 1px solid #ebeef5;
}

:deep(.el-table--border td) {
  border-right: 1px solid #ebeef5;
}

:deep(.el-table--border::after) {
  background-color: #ebeef5;
}

:deep(.el-table--border::before) {
  background-color: #ebeef5;
}

/* 按钮文本溢出处理 */
:deep(.el-table .cell .el-button) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}

/* 加载样式 */
:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.8);
}

/* 分页样式 */
:deep(.el-pagination) {
  padding: 0;
}

:deep(.el-pagination .el-select .el-input .el-input__inner) {
  padding-right: 25px;
}

/* Tooltip 样式优化 */
:deep(.el-tooltip__popper) {
  max-width: 400px;
  word-break: break-all;
  line-height: 1.5;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .table-container {
    padding: 15px;
  }

  .header {
    padding: 15px 20px;
  }

  .page-title {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .table-container {
    padding: 10px;
  }

  .header {
    padding: 12px 15px;
  }

  .page-title {
    font-size: 18px;
  }

  .pagination-container {
    justify-content: center;
  }

  :deep(.el-pagination) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  :deep(.el-tooltip__popper) {
    max-width: 300px;
  }
}
</style>
